module.exports = __webpack_public_path__ + "static/media/Glitch-6.e9d228d3.webp";